import {  useState } from 'react'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { GetDataOptions, useVisitorData } from '@fingerprintjs/fingerprintjs-pro-react'
import { supabase } from "@/integrations/supabase/client";
import { ExtendedGetResult } from '@fingerprintjs/fingerprintjs-pro';
import { getAffiliateIdFromCookie, getCampaignCookie, getReferralCodeFromCookie } from '@/hooks/referrals/referralUtils';

export type FingerprintData = {
  visitor_id?: any
  affiliate_id?: any,
  campaign?: any
  referrale_code?: any
  fingerprint_data: EntropyFingerprint
}

export type EntropyFingerprint = {
    ip?: string
    platform?: any
    os?: any
    os_version?: string
    screen_resolution?: any
    device_memory?: any
    hardware_concurrency?: any
    timezone?: any
    clock_skew_ms?: any
    webgl?: any
  }
  
  export function compareDeviceSnapshots(): number {

  return 0;
}  

export function useFingerprintCompare(): {
  loading: boolean,
  data: any | null,
  compare: () => Promise<void>;
} {

  const { getData } = useVisitorData(
    { extendedResult: true },
    { immediate: false }
);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<EntropyFingerprint | null>(null);

  const compare = async () => {
    var { body }: { body: FingerprintData; } = await getFingerprint(getData);

    const { data: compare, error: compare_error } = await supabase.functions.invoke(`compare-fingerprint`,
      { 
        body: body
      }
    );

    if(compare){
      console.log(compare);
      setData(compare); 
      setLoading(false);
    }
  };

  return { loading, data, compare };
}

export function useFingerprint(): {
    loading: boolean
    data: EntropyFingerprint | null,
    store: () => Promise<void>;
} {
    
  const { getData } = useVisitorData(
    { extendedResult: true },
    { immediate: false }
);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState<EntropyFingerprint | null>(null);

    const store = async () => {
      var { body }: { body: FingerprintData; } = await getFingerprint(getData);

      const { data: insert, error: insert_error } = await supabase.functions.invoke(`store-fingerprint`,
        { 
          body: body
        }
      );


      console.log("[Fingerprint]: ",body);

      setData(body.fingerprint_data);
      setLoading(false);
  }

    return { loading, data, store }
}

async function getFingerprint(getData: (getDataOptions?: GetDataOptions<true>) => Promise<ExtendedGetResult>) {

  const clientSentTime = Date.now();
  const { data: clock_skew_ms_data } = await supabase.functions.invoke(`store-fingerprint?clientTime=${clientSentTime}`);
  const clientReceivedTime = Date.now();
  let clock_skew_ms = null;
  if (clock_skew_ms_data && clock_skew_ms_data.serverTime) {
    const averageClientTime = (clientSentTime + clientReceivedTime) / 2;
    console.log(clock_skew_ms_data);
    clock_skew_ms = clock_skew_ms_data.serverTime - averageClientTime;
    console.log('csms: ', clock_skew_ms);
  }

  const fp = await FingerprintJS.load()
  const result = await fp.get();

  console.log(result);
  const proResult = await getData({ extendedResult: true });

  const raw = result.components;

  const selected: EntropyFingerprint = {
    platform: raw.platform,
    os: proResult.os,
    os_version: proResult.osVersion,
    ip: proResult.ip,
    screen_resolution: raw.screenResolution,
    device_memory: raw.deviceMemory,
    hardware_concurrency: raw.hardwareConcurrency,
    timezone: raw.timezone,
    clock_skew_ms: clock_skew_ms,
    webgl: raw.webGlBasics
  };

  var campaign = getCampaignCookie();
  var affiliate_id = getAffiliateIdFromCookie();
  var referral_code = getReferralCodeFromCookie();

  var body: FingerprintData = {
    visitor_id: proResult.visitorId,
    campaign: campaign,
    affiliate_id: affiliate_id,
    referrale_code: referral_code,
    fingerprint_data: selected
  };
  return { body };
}
